<div class="main">
        <div class="listWrap">
            <div class="footerWrap">
                <h2>Who we are</h2>
                <ul class="footerlist">
                    <li><a [routerLink]="['/about']">About Us</a></li>
                  <!--   <li><a [routerLink]="['/Careers']">Careers</a></li> -->
    
                </ul>
            </div>
        </div>
        <div class="listWrap">
            <div class="footerWrap">
                <h2>What We Do</h2>
                <ul class="footerlist">
                    <li><a [routerLink]="['/industries']">Industries</a></li>
                    <li><a [routerLink]="['/technology']">Technologies</a></li>
                    <li><a [routerLink]="['/services']">Services</a></li>
                  <!--   <li><a [routerLink]="['/featured-products']">Featured Projects</a></li> -->
                    <li><a [routerLink]="['/client']">Clientele</a></li>
                </ul>
            </div>
        </div>
        <div class="listWrap" style="width: 20%;">
            <div class="footerWrap">
                <h2>Contact Us</h2>
                <ul class="footerlist iconFooterList">
                    <li style="margin-bottom: 7px;">
                        <span>
                            <a href="tel:+919654854895">
                                <img src="../../../assets/images/patch/call.png" style="width:30px;">
                            </a>
                            </span>
                        <span>
                            <a href="tel:+919654854895">
                                +91-9654854895
                            </a>
                        </span>
                     
                    </li>
                    <li style="margin-bottom: 7px;">
                        <span>
                            <a href="mailto:contactus@patchinfotech.com">
                                <img src="../../../assets/images/patch/mail.png" style="width:30px;">
                            </a>
                        </span>
                        <span>
                            <a href="mailto:contactus@patchinfotech.com">
                                contactus@patchinfotech.com
                            </a>
                        </span>
                    
                    </li>
                </ul>
            </div>
        </div>
        <div class="listWrap">
            <div class="footerWrap">
                <h2>Address</h2>
                <ul class="footerlist">
                    <li><a>91springboard, Building Number 145, Sector 44 Rd, Sector 44, Gurgaon - 122003</a></li>
                   
                </ul>
            </div>
        </div>
       
        <div class="listWrap forCenterAlign">
            <div class="footerWrap">
                <div class="copyRight">
                    <img src="../../../assets/images/patch/logo/logo2.png">
                <p>©2020 Patch Infotech</p>
                </div>
    
        </div>
    
    </div>
    </div>